import { ApiPath } from '@/common/app/api-path';
import { type AppleCredentials } from '@/common/lib/apple-sign-in';
import {
  type AuthEmailRequestType,
  type VerifyEmailRequestType,
} from '@/common/types/auth';
import {
  type TonAuthGeneratePayloadResponse,
  type TonAuthLoginRequest,
} from '@/common/types/ton-auth';
import { type User } from '@/common/types/userType';

import { api } from '../base';

const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    loginWithEmail: builder.mutation<void, AuthEmailRequestType>({
      query: (body) => ({
        url: ApiPath.AUTH_EMAIL,
        method: 'POST',
        body,
      }),
    }),
    verifyEmail: builder.mutation<void, VerifyEmailRequestType>({
      query: (body) => ({
        url: ApiPath.EMAIL_VERIFY,
        method: 'POST',
        body,
      }),
    }),
    tonGeneratePayload: builder.query<TonAuthGeneratePayloadResponse, void>({
      query: () => ApiPath.TON_AUTH_GENERATE_PAYLOAD,
    }),
    tonLogin: builder.mutation<User, TonAuthLoginRequest>({
      query: (body) => ({
        url: ApiPath.TON_AUTH_LOGIN,
        method: 'POST',
        body,
      }),
    }),
    telegramNativeStart: builder.mutation<
      { state: string; authUrl: string },
      { platform: string; link?: boolean }
    >({
      query: (body) => ({
        url: ApiPath.AUTH_TELEGRAM_NATIVE_START,
        method: 'POST',
        body,
      }),
    }),
    guestLogin: builder.mutation<User, { deviceId: string }>({
      query: (body) => ({
        url: ApiPath.AUTH_GUEST,
        method: 'POST',
        body,
      }),
    }),
    appleLogin: builder.mutation<User, AppleCredentials>({
      query: (body) => ({
        url: ApiPath.AUTH_APPLE,
        method: 'POST',
        body,
      }),
    }),
    linkApple: builder.mutation<User, AppleCredentials>({
      query: (body) => ({
        url: ApiPath.AUTH_LINK_APPLE,
        method: 'POST',
        body,
      }),
    }),
    deleteAccount: builder.mutation<void, void>({
      query: () => ({
        url: ApiPath.AUTH_DELETE_ACCOUNT,
        method: 'POST',
      }),
    }),
    telegramNativePoll: builder.mutation<
      { status: 'pending' | 'ok' | 'denied' | 'conflict'; user?: User },
      { state: string }
    >({
      query: (body) => ({
        url: ApiPath.AUTH_TELEGRAM_NATIVE_POLL,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useLoginWithEmailMutation,
  useVerifyEmailMutation,
  useLazyTonGeneratePayloadQuery,
  useTonLoginMutation,
  useTelegramNativeStartMutation,
  useTelegramNativePollMutation,
  useGuestLoginMutation,
  useAppleLoginMutation,
  useLinkAppleMutation,
  useDeleteAccountMutation,
} = authApi;
export { authApi };
